import { lazy } from 'react'
import { type RouteObject } from 'react-router-dom'

const TugasPemindahanNgPage = lazy(() => import('./pages/tugas-pemindahan-ng'))

/** Cluster C14 Penanganan NG RM — DSR-03 Tugas Pemindahan Barang NG (Mobile Scan): rak → Area Not Good → Area Pemusnahan. */
const ngHandlingRmRoutes: RouteObject[] = [
  {
    path: 'ng-handling-rm',
    children: [{ path: 'tugas-pemindahan-ng', element: <TugasPemindahanNgPage /> }]
  }
]

export default ngHandlingRmRoutes
